import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { api, imgUrl } from "@/lib/api";
import { Stars } from "@/components/Stars";
import { HOME } from "@/constants/testIds";

export const PhotoOfTheWeek = () => {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/reviews/photo-of-the-week").then(({ data }) => setR(data)).catch(() => {}); }, []);
  if (!r) return null;
  const who = r.pet_name || r.name;
  return (
    <section data-testid={HOME.photoOfWeek} className="max-w-7xl mx-auto px-6 lg:px-10 pt-16">
      <div className="grid md:grid-cols-[minmax(0,380px)_1fr] gap-8 items-center bg-[#F2E8DA] rounded-[2rem] p-5 sm:p-8 fade-up">
        <Link to={`/product/${r.slug}#review-${r.id}`} className="block aspect-square rounded-[1.5rem] overflow-hidden">
          <img src={imgUrl(r.photo)} alt={who ? `${who} with ${r.product_name}` : `A happy pet with ${r.product_name}`} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
        </Link>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-[#E06D44] font-semibold">Pet of the week</p>
          <h2 data-testid={HOME.photoOfWeekTitle} className="font-heading mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight">
            Thank you{who ? `, ${who}` : ""}!
          </h2>
          <p className="mt-4 text-stone-700 leading-relaxed max-w-xl">
            Kiddee&rsquo;s favorite photo this week. Every review and pet photo helps another pet parent pick the right toy, so from all of us at PetTok: thank you for sharing.
          </p>
          {r.text && <blockquote className="mt-5 border-l-4 border-[#E06D44] pl-4 text-stone-700 italic">{r.text}</blockquote>}
          <div className="mt-5 flex flex-wrap items-center gap-3 text-sm">
            <Stars value={r.rating} size={15} />
            <Link to={`/product/${r.slug}`} data-testid={HOME.photoOfWeekProduct} className="font-semibold hover:text-[#E06D44] transition-colors">{r.product_name}</Link>
          </div>
          <p className="mt-6 flex items-center gap-2 text-xs text-stone-500"><Heart size={14} className="text-[#E06D44]" /> Bought something? Add your pet&rsquo;s photo with your review for a chance to be next week&rsquo;s star.</p>
        </div>
      </div>
    </section>
  );
};
